import { Col, Row } from "antd";
import React from "react";
import "./nucleusteqVoiceImages.scss";

type Props = {
  nucleusteqVoiceImages: {
    name: string;
    desigination: string;
    thoughts: string;
    images: string;
  }[];
};

const NucleusteqVoiceImages = ({ nucleusteqVoiceImages }: Props) => {
  return (
    <div>
      <Row justify={"space-around"}>
        {nucleusteqVoiceImages.map((data, i) => {
          return (
            <>
            <Col></Col>
            <Col xs={24} sm={24} md={10} lg={9} xl={5} xxl={5} style={{paddingBottom:"2vw"}}>
              <div className="NucleusteqVoiceImages_images"
                style={{
                  background: `url("${data.images}") no-repeat center center`,
                  backgroundSize: "cover",
                }}
              />
              <div className="NucleusteqVoiceImages_name">{data.name}</div>
              <div className="NucleusteqVoiceImages_designation">
                {data.desigination}
              </div>
              <div>
               <p  className="NucleusteqVoiceImages_thought"> {data.thoughts}</p>
              </div>
            </Col>
            </>
          );
        })}
      </Row>
    </div>
  );
};

export default NucleusteqVoiceImages;
